export default function hasInternet(): boolean {
  return window.navigator.onLine
}
